import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import HomePage from '@/components/HomePage'
import News from '@/components/News'
import About from '@/components/About'

Vue.use(Router)

export default new Router({
  mode: 'history',
  // scrollBehavior: function(to, from, savedPosition) {
  //   if (to.hash) {
  //       return {selector: to.hash}
  //   } else {
  //       return { x: 0, y: 0 }
  //   }
  // },
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/:url',
      name: 'HomePage',
      component: HomePage
    },
    // {
    //   path: '/home/:url',
    //   name: 'HomePage',
    //   component: HomePage
    // },
    {
      path: '/news/:id',
      name: 'News',
      component: News
    },
    {
      path: '*',
      redirect: '/about'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js